import { useCallback, useEffect, useState } from "react";

export const SwapIcon = () => (
  <svg
    height=".9em"
    viewBox="0 0 12 12"
    width=".8em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 3.5a.5.5 0 0 1 0-1h9.5a.5.5 0 1 1 0 1H1z" fill="currentColor" />
    <path
      d="M8.264.85a.5.5 0 1 1 .716-.7l2.378 2.438a.5.5 0 0 1 0 .699l-2.5 2.562a.5.5 0 1 1-.716-.698l2.16-2.214L8.263.85zM3.736 11.15a.5.5 0 1 1-.716.7L.642 9.411a.5.5 0 0 1 0-.699l2.5-2.562a.5.5 0 0 1 .716.698l-2.16 2.214 2.038 2.088z"
      fill="currentColor"
    />
    <path
      d="M1.5 9.5a.5.5 0 0 1 0-1H11a.5.5 0 1 1 0 1H1.5z"
      fill="currentColor"
    />
  </svg>
);
export const SwapButton = ({
  className = "",
  label,
  onClick,
  announcement,
}: {
  className?: string | undefined;
  onClick: () => void;
  label: string;
  announcement?: string;
}) => {
  const [flip, setFlip] = useState(false);
  const [liveText, setLiveText] = useState("");

  const handleClick = useCallback(() => {
    setFlip((v) => !v);
    onClick();
  }, [onClick]);

  useEffect(() => {
    if (!announcement) {
      return;
    }
    setLiveText(announcement);
    requestAnimationFrame(() => {
      setLiveText("");
    });
  }, [announcement, flip]);

  return (
    <>
      <span
        aria-atomic="true"
        aria-live="polite"
        className="sr-only"
        role="status"
      >
        {liveText}
      </span>
      <button
        aria-label={label}
        className={`${className} z-2 order-2 -mx-2.5 mt-4 flex size-6 cursor-pointer items-center justify-center rounded-full border border-medium-gray bg-white text-royal-blue transition-all focus-within:outline-core-blue hover:bg-royal-blue hover:text-white data-[flip=false]:rotate-0 data-[flip=true]:rotate-180`}
        data-flip={flip}
        onClick={handleClick}
        type="button"
      >
        <SwapIcon aria-hidden />
      </button>
    </>
  );
};
